import React, { useContext } from 'react';

import { FlagsContext } from 'src/context';
import { OptionChip } from 'src/legacy/components/MultiSelect/OptionChip';
import { MultiSelectOption } from 'src/legacy/components/Select/types';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseChip, TruncatedText } from 'src/legacy/components/UI';
import { CATEGORICAL_COLOR_TO_LEGACY_COLOR, LightGray } from 'src/theme/colors';
import ColorUtils, { isCategoricalColor } from 'src/utils/ColorUtils';

interface MultiSelectInputProps {
  selectedTags: Array<MultiSelectOption>;
  tagsLimit?: number;
}

export const MultiSelectInput: React.FC<MultiSelectInputProps> = ({
  selectedTags,
  tagsLimit = 3,
}) => {
  const { EnableTagsMultiSelectUIRedesign } = useContext(FlagsContext);
  return selectedTags ? (
    <div className="w-full flex items-center flex-wrap cursor-pointer">
      {selectedTags.map((optionValue, index) => {
        const showOption = tagsLimit ? index < tagsLimit : true;
        return (
          showOption && (
            <div key={optionValue.id} className="p-1">
              {EnableTagsMultiSelectUIRedesign ? (
                <OptionChip
                  className="[&>p]:truncate [&>p]:max-w-[70px]"
                  label={optionValue.label}
                  color={optionValue.color}
                />
              ) : (
                <BaseChip
                  label={
                    <TruncatedText
                      styleProps={{
                        color: isCategoricalColor(optionValue.color)
                          ? CATEGORICAL_COLOR_TO_LEGACY_COLOR[optionValue.color]
                          : optionValue.color,
                      }}
                      text={optionValue.label}
                      maxChars={10}
                    />
                  }
                  style={{
                    backgroundColor: ColorUtils.GetColorDarknessShades(
                      isCategoricalColor(optionValue.color)
                        ? CATEGORICAL_COLOR_TO_LEGACY_COLOR[optionValue.color]
                        : optionValue.color,
                    ).light,
                    cursor: 'pointer',
                  }}
                />
              )}
            </div>
          )
        );
      })}
      {tagsLimit && (selectedTags?.length ?? 0) > tagsLimit && (
        <BaseTypography fontType="12Medium" style={{ color: LightGray }}>
          + {(selectedTags?.length ?? 0) - tagsLimit}
        </BaseTypography>
      )}
    </div>
  ) : null;
};
